import { PacketDetailLabels } from 'components/DeviceView/DeviceViewContent/PacketDetail/PacketDetailLabels';
import { PacketDetailTrafficScore } from 'components/DeviceView/DeviceViewContent/PacketDetail/PacketDetailTrafficScore';
import type { GraphPathLookupPathInspectorEdgeTooltipPayload } from 'components/Graph/GraphTooltip/GraphTooltipPayload';
import { selectNodesStableData } from 'components/Graph/model/selectors/selectNodesStableData';
import { type FC, memo } from 'react';
import { useGraphContextSelectors } from '../GraphContext';
import { selectPathLookupEdgeTooltipEdgeData } from '../model/selectors/selectPathLookupEdgeTooltipEdgeData';

interface Props {
  payload: GraphPathLookupPathInspectorEdgeTooltipPayload;
}

const BareGraphPathLookupEdgeTooltip: FC<Props> = (props) => {
  const ctxProps = useGraphContextSelectors({
    edgeData: selectPathLookupEdgeTooltipEdgeData,
    graphNodes: selectNodesStableData,
  });

  if (
    ctxProps.edgeData === null ||
    ctxProps.edgeData.labels === undefined ||
    ctxProps.edgeData.direction === null ||
    ctxProps.edgeData.trafficScore === null ||
    props.payload.edgeId === null
  ) {
    return null;
  }

  return (
    <div className='path-lookup-edge-tooltip'>
      <PacketDetailLabels
        detailId={props.payload.edgeId}
        edgeDirection={ctxProps.edgeData.direction}
        labels={ctxProps.edgeData.labels}
        sourceLabel={
          ctxProps.graphNodes[ctxProps.edgeData.source]?.label ?? null
        }
        targetLabel={
          ctxProps.graphNodes[ctxProps.edgeData.target]?.label ?? null
        }
      />
      <PacketDetailTrafficScore trafficScore={ctxProps.edgeData.trafficScore} />
    </div>
  );
};

export const GraphPathLookupEdgeTooltip = memo(BareGraphPathLookupEdgeTooltip);
